import React, { useState } from "react";
import { Button, Container, Dropdown, DropdownButton } from "react-bootstrap";
import CategoryDropDown from "../components/dropdowns/categoryDropdown";
import DocumentsDropDown from "../components/dropdowns/documents";
import Header from "../components/header";
import Footer from "../components/footer";
import { FaTimes } from "react-icons/fa";
import useCategoryTree from "../services/useCategoryTree";
import SiteWarning from "../components/siteWarning";
import AppSettings from "../configs/appSettings";
import { useGtagTracker } from "../services/useGtagTracker";
import { useEffect,useLayoutEffect } from "react";
import { Link } from "react-router-dom";


const MasterPage: React.FC = (props) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!open);
  const { tree, isLoading, error } = useCategoryTree();
  const [currentCategoryID, setCurrentCategoryID] = useState(window.localStorage.getItem("currentCategoryID"));      
  const [showSub,setShowSub]=useState(false);
  useGtagTracker(); 

  useLayoutEffect(() => {
    setCurrentCategoryID(window.localStorage.getItem("currentCategoryID"))
  })

  const documentDrop=() => {    
    setOpen(false);    
    setShowSub(true);      
    }
    
    return (
    <>
      <Header toggleOpen={toggleOpen} />
      <Container
        className={`landing-page-dropdown-container ${open ? "visible" : ""}`}
      >
        <div className="close" onClick={() => setOpen(false)}>
          <FaTimes />
        </div>
        {tree &&
          tree.children.map((it, index) =>
            it.children.length > 0 ? (
              <CategoryDropDown
                key={index}
                category={it}  
                currentCategoryID={currentCategoryID}               
                onItemSelected={() => {setOpen(false);
                window.localStorage.setItem("currentCategoryID",it.categoryTagId);    
                setCurrentCategoryID(window.localStorage.getItem("currentCategoryID"));  
                }}                  
              />
            ) : null
          )}
          {
            tree && 
                  <Link to="#" onClick={documentDrop}>
                  <Button
                    variant={`${currentCategoryID=="document"?"primary":"dark"}`}
                    className="company-info-dropdown"
                    id="dropdown-basic-button"
                    title="DOCUMENTS"
                  >
                    DOCUMENTS
                  </Button>
                </Link>
          }
       
      </Container>

      <DocumentsDropDown currentCategoryID={currentCategoryID} showDocumentSub={showSub} setShowDocumentSub={(param: boolean)=>setShowSub(param)}/>
      <div id="page-body">{props.children}</div>
      <Footer />
      {AppSettings.Environment !== "production" && <SiteWarning />}
    </>
  );
};

export default MasterPage;
